module.exports = {
  AnimationOptions: {
    PluginName: "Animasyonlar",
    border_color: "Çerçeve rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Saydamlık",
    padding: "Alan",
    pos: "Konum",
    background_color: "Arka Plan Rengi",
    radius: "Radyan",
    source: "Kaynak",
    scale: "Zoom",
    message_mark_xy: "Yanlış bir değer seçtiniz. Sayıları birbirinden virgül ile ayırmalısınız",
    hyperlink: "Link",
    link_placeholder: "http://...",
    allowDeformed: "Konteyner Ayarı",
    replayWebp: "Sahne başladığında tekrar oynat (WebP / GIF)",
  },
};
